<template>
  <div class="relative flex items-center py-2.5">
    <div class="flex h-6 items-center">
      <input
        :id="option.value.toString()"
        v-model="sizeStore.selectedSizeOption"
        :value="option"
        type="radio"
        class="h-4 w-4 border-black text-transparent checked:border-2 checked:border-black hover:border-2 hover:border-black checked:hover:border-2 checked:hover:border-black focus:border-2 focus:border-black focus:ring-transparent checked:focus:border-2 checked:focus:border-black active:border-2 active:border-black"
      />
    </div>

    <label
      :for="option.value.toString()"
      class="ml-2 flex w-full cursor-pointer justify-between gap-2 leading-6"
    >
      <span
        class="flex items-center justify-center gap-1.5 md:items-start lg:flex-row"
      >
        <span class="text-gray-900">
          {{ option.label }}
        </span>

        <BadgeLabel
          v-if="
            sizeStore.showMostChosenBadge &&
            option.value.toString() === sizeStore.mostChosenSku
          "
          :label="$t('pages.configurator.sizes.most_chosen')"
          class="shrink-0 self-auto bg-order-buttons/20 text-order-buttons"
        />
      </span>

      <FilterPrices v-bind="{ option }" />
    </label>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import type { SelectorOption } from '@/types/Configurator/SelectorOption';
import { useSizeStore } from '@/stores/Configurator/SizeStore.ts';
import BadgeLabel from '@/components/BadgeLabel.vue';
import FilterPrices from '@/pages/ProductPage/partials/ProductFilters/FilterPrices.vue';

defineProps({
  option: {
    type: Object as PropType<SelectorOption>,
    required: true,
  },

  customSizeRadioButtonId: {
    type: String,
    required: false,
    default: 'custom-size-radio-button-desktop',
  },

  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const sizeStore = useSizeStore();
</script>
